module.exports = __webpack_public_path__ + "img/ic_codeshare.c12c02d6.svg";